import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { RolloutRequest } from '@/definitions/featureFlags'
import { RollOutFeatureFlag } from '@/services/FeatureFlagService'

interface RollOutFeatureFlagVariables {
  name: string
  data: RolloutRequest
}

export const useRollOutFeatureFlag = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ name, data }: RollOutFeatureFlagVariables) =>
      RollOutFeatureFlag(name, data),
    // The rollout renders its own per-organization report, including the failures.
    meta: { suppressGlobalError: true },
    onSuccess: () => {
      // Any organization in the batch may now hold a row, and the tabs are keyed
      // per organization, so the whole family is invalidated rather than guessed at.
      queryClient.invalidateQueries({ queryKey: ['org-feature-flags'] })
    },
  })
}
